// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mapTitleDiv[data-v-5a5c5dde] {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  border-radius: 10px;\n  background-color: #283046 !important;\n  color: #fff;\n  padding: 5px 10px;\n  font-weight: 700;\n  z-index: 2000;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
